"use client";

import { useState } from "react";
import { useSearchResults } from "./api";
import { ContentType } from "./content_types";
import { ContentTypesInput } from "./inputs/content_types";
import { QueryInput } from "./inputs/query";
import { Results } from "./results";

export function OmniSearch() {
  const [query, setQuery] = useState("");
  const [contentTypes, setContentTypes] = useState<ContentType[]>([]);
  const { results, error, isError, isLoading } = useSearchResults(query, contentTypes);

  return (
    <div className="flex flex-col gap-[20px] p-[20px] bg-iq-grey-lighter rounded-[var(--iq-border-radius-md)] shadow-[var(--iq-box-shadow-lg)] max-h-[calc(100vh-60px)] lg:w-[720px]">
      <QueryInput value={query} onChange={setQuery} isLoading={isLoading} />
      <ContentTypesInput value={contentTypes} onChange={setContentTypes} />
      {isLoading && <p>Searching Interview Query...</p>}
      {isError && (
        <div className="bg-red-100 text-red-700 rounded-[var(--iq-border-radius-md)] p-[10px]">
          {error}
        </div>
      )}
      {!isLoading && !isError && <Results results={results} />}
    </div>
  );
}
